import { app } from "../../app"

/**
 * 上传之前
 * @param file
 * @returns {Promise}
 */
function beforeUpload (file) {
    const imgs = ['image/jpeg', 'image/png']
    if (imgs.indexOf(file.type) === -1) {
        app.alert('请上传jpg或png图片！')
        return Promise.reject(false)
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        app.alert('上传图片最大2M！')
        return Promise.reject(false)
    }
    return Promise.resolve(true)
}

export default {
    beforeUpload
}



// WEBPACK FOOTER //
// ./src/routes/report/common.js